import styles from "./PageChooser.module.css";
import {Button} from "@/components/ui/button";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

type PageChooserProps =
  | WithPrevPageProps
  | WithoutPrevPageProps
  | WithouNextPageProps;

interface WithPrevPageProps {
  onPrevPage: () => void;
  onNextPage: () => void;
  prevPageEnabled: true;
  nextPageEnabled: true;
  prevPageText: string;
  nextPageText: string;
}

interface WithoutPrevPageProps {
  onNextPage: () => void;
  prevPageEnabled: false;
  nextPageEnabled: true;
  nextPageText: string;
}

interface WithouNextPageProps {
  onPrevPage: () => void;
  prevPageEnabled: true;
  prevPageText: string;
  nextPageEnabled: false;
}
const PageChooser = (props: PageChooserProps) => {
  return (
    <div className={styles.spacer}>
      {props.prevPageEnabled ? (
        <Button onClick={props.onPrevPage} size="sm" variant="secondary">
          <FaArrowLeft />
          {props.prevPageText}
        </Button>
      ) : null}
      {props.nextPageEnabled ? (
        <Button
          onClick={props.onNextPage}
          size="sm"
          variant="secondary"
        >
          {props.nextPageText}
          <FaArrowRight />
        </Button>
      ) : null}
    </div>
  );
};

export default PageChooser;
